import { forwardRef } from 'react'
import { StyledFieldset } from './style'
import { iInputProps } from './types';

export const Input = forwardRef<HTMLInputElement, iInputProps>(
  ({ children, type, placeholder, id, ...rest }, ref) => (
    <StyledFieldset>
      <label htmlFor={id}>{children}</label>
      <input
        type={type}
        placeholder={placeholder}
        id={id}
        {...rest}
        ref={ref}
      />
    </StyledFieldset>
  )
);